import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tab} from 'semantic-ui-react';

import {prettyXAxisLabel} from '../../../util/plotHelpers/axis';
import {Line} from '../../../util/plotHelpers/types';
import * as QueryTypes from '../../../util/queryTypes';
import PanelDisplayPreferences from '../../PanelDisplayPreferences';
import {defaultTitle} from '../common';
import {usePanelConfigContext} from '../PanelConfigContext';
import {RunsLinePlotConfig} from '../types';

type EditDisplayPreferencesTabProps = {
  config: RunsLinePlotConfig;
  updateConfig: (config: Partial<RunsLinePlotConfig>) => void;
  pageQuery: QueryTypes.Query;
  lines: Line[];
};

export const EditDisplayPreferencesTab = (
  props: EditDisplayPreferencesTabProps
) => {
  const {getDefaultLegendTemplateByRunsetId, xAxis} = usePanelConfigContext();
  return (
    <Tab.Pane as="div" className="form-grid">
      <PanelDisplayPreferences
        config={props.config}
        defaultLegendTemplate={
          // This is just the initial value of the default template for the Advanced editor on the config. We can just
          // use the first runset id's default template.
          getDefaultLegendTemplateByRunsetId(
            props.pageQuery.runSets?.[0]?.id ?? ''
          )
        }
        defaultTitle={defaultTitle(props.config)}
        defaultXAxisTitle={prettyXAxisLabel(xAxis, props.lines)}
        editableLegendSeries={props.lines.filter(l => !l.aux && l.name != null)}
        pageQuery={props.pageQuery}
        type={'lines'}
        updateConfig={props.updateConfig}
      />
    </Tab.Pane>
  );
};
